<template>
  <div class="container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <p>暂未开放!</p>
    </el-card>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 70px);
  padding: 10px 16px;
  // height: calc(100vh - 90px);
  // margin: 20px;
  // background-color: #fff;

  .el-breadcrumb {
    margin: 20px;
  }
  .el-card {
    height: calc(100vh - 134px);
    p {
      margin-top: 300px;
      text-align: center;
      font-size: 26px;
      color: #f56c6c;
      font-weight: 600;
      letter-spacing: 0.5em;
    }
  }
}
</style>
